"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var match_1 = __importDefault(require("autosuggest-highlight/match"));
var parse_1 = __importDefault(require("autosuggest-highlight/parse"));
var classnames_1 = __importDefault(require("classnames"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var react_1 = __importStar(require("react"));
// tslint:disable-next-line: max-line-length
var react_autosuggest_1 = __importDefault(require("react-autosuggest"));
var Input_1 = __importDefault(require("../Input"));
var index_1 = __importDefault(require("../LocaleProvider/index"));
/*
 * You can supply suggestions reactively using suggestions prop or supply getInitialSuggestions prop,
 * that is called once to get suggestions.
 * If custom filtering is needed e.g. get suggestions using input from backend or custom filtering on already
 * supplied suggestions, use searchSuggestions prop
 */
var AutoCompleteInput = /** @class */ (function (_super) {
    __extends(AutoCompleteInput, _super);
    function AutoCompleteInput(props) {
        var _this = _super.call(this, props) || this;
        _this.localeChanged = function () {
            _this.forceUpdate();
        };
        _this.shouldRenderSuggestions = function (input) {
            return _this.props.renderSuggestionsOnFocus || !!input.trim();
        };
        _this.onSuggestionsClearRequested = function () {
            _this.setState({ suggestions: [] });
        };
        _this.onSuggestionsFetchRequested = function (_a) {
            var value = _a.value, reason = _a.reason;
            return __awaiter(_this, void 0, void 0, function () {
                var suggestions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            suggestions = this.state.lastSuggestions;
                            if (!(reason === "input-changed")) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getFilteredSuggestions(value, suggestions)];
                        case 1:
                            suggestions = _b.sent();
                            _b.label = 2;
                        case 2:
                            this.setState({
                                suggestions: suggestions,
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.onInputChange = function (_event, _a) {
            var newValue = _a.newValue, method = _a.method;
            _this.setState({ inputValue: newValue });
            if (_this.props.onInputChange && method !== "down" && method !== "up") {
                // Pass only on submission, not arrow up/down
                _this.props.onInputChange(newValue);
            }
        };
        _this.onInputKeyDown = function (event) {
            if (event.key === "Enter" && !event.isDefaultPrevented() && _this.props.preventEnterOnSuggestionSelection) {
                event.preventDefault();
            }
            // Pass data to input props
            if (_this.props.inputProps && _this.props.inputProps.onKeyDown) {
                _this.props.inputProps.onKeyDown(event);
            }
        };
        _this.renderInputComponent = function (inputProps) {
            // For somehow IE11 has broken WIA_ARIA support
            delete inputProps["aria-autocomplete"];
            delete inputProps["aria-controls"];
            // This is problem, because AutosuggestInputProps has different onChange than inputProps of <input
            return react_1.default.createElement(Input_1.default, __assign({}, inputProps));
        };
        _this.renderSuggestion = function (suggestion, _a) {
            var query = _a.query;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var suggestionLabel = _this.props.getSuggestionValue(suggestion);
            var matches = match_1.default(suggestionLabel, query);
            var parts = parse_1.default(suggestionLabel, matches);
            return (react_1.default.createElement("span", null, parts.map(function (part, index) {
                var className = part.highlight ? "highlight" : "";
                return (react_1.default.createElement("span", { className: className, key: index }, part.text));
            })));
        };
        _this.renderSuggestionContainer = function (_a) {
            var containerProps = _a.containerProps, children = _a.children;
            var _b = _this.props, onDeleteSuggestionsClick = _b.onDeleteSuggestionsClick, showHeaderText = _b.showHeaderText, showDeleteText = _b.showDeleteText;
            var _c = index_1.default.locs.autocomplete, headerText = _c.headerText, deleteSuggestionsText = _c.deleteSuggestionsText;
            return (react_1.default.createElement("div", __assign({}, containerProps, { className: classnames_1.default(containerProps.className), style: __assign({}, containerProps.style) }),
                showHeaderText && headerText && react_1.default.createElement("span", { className: "emankit__autocomplete__header" }, headerText),
                children,
                showDeleteText && deleteSuggestionsText && (react_1.default.createElement("a", { className: "respectkit__autocomplete__delete", onClick: onDeleteSuggestionsClick }, deleteSuggestionsText))));
        };
        _this.onSuggestionSelected = function (event, data) {
            if (event.key === "Enter" && _this.props.preventEnterOnSuggestionSelection) {
                event.preventDefault();
            }
            _this.props.onSelected(data.suggestion);
        };
        // tslint:disable-next-line:member-ordering
        _this.debouncedFetchRequest = debounce_1.default(_this.onSuggestionsFetchRequested, 500);
        _this.id = (AutoCompleteInput.id++).toString();
        index_1.default.on(_this.localeChanged);
        _this.state = {
            suggestions: props.suggestions || [],
            lastSuggestions: props.suggestions || [],
            value: props.value,
            inputValue: AutoCompleteInput.suggestionValue(props),
        };
        return _this;
    }
    AutoCompleteInput.suggestionValue = function (props) {
        if (!props.value) {
            return "";
        }
        else if (props.getSuggestionValue) {
            return props.getSuggestionValue(props.value);
        }
        else {
            /* eslint-disable-next-line @typescript-eslint/no-unsafe-return */
            return props.value; // Horrible hack..
        }
    };
    // tslint:disable-next-line: max-line-length
    AutoCompleteInput.getDerivedStateFromProps = function (nextProps, prevState) {
        var newState = null;
        if (!nextProps.getInitialSuggestions && prevState.lastSuggestions !== nextProps.suggestions) {
            newState = {
                suggestions: nextProps.suggestions || [],
                lastSuggestions: nextProps.suggestions || [],
            };
        }
        if (nextProps.value !== prevState.value) {
            newState = __assign(__assign({}, (newState || {})), { value: nextProps.value, inputValue: AutoCompleteInput.suggestionValue(nextProps) });
        }
        return newState;
    };
    AutoCompleteInput.prototype.componentWillUnmount = function () {
        index_1.default.off(this.localeChanged);
    };
    AutoCompleteInput.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var initialSuggestions, suggestions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.getInitialSuggestions) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.getInitialSuggestions()];
                    case 1:
                        initialSuggestions = _a.sent();
                        return [4 /*yield*/, this.getFilteredSuggestions(this.state.inputValue, initialSuggestions)];
                    case 2:
                        suggestions = _a.sent();
                        this.setState({ suggestions: suggestions, lastSuggestions: initialSuggestions });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AutoCompleteInput.prototype.getFilteredSuggestions = function (input, suggestions) {
        return __awaiter(this, void 0, void 0, function () {
            var regex_1;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.props.searchSuggestions) {
                    return [2 /*return*/, this.props.searchSuggestions(input, suggestions)];
                }
                else if (suggestions && input) {
                    regex_1 = new RegExp(input, "i");
                    /* eslint-disable-next-line @typescript-eslint/prefer-regexp-exec */
                    return [2 /*return*/, suggestions.filter(function (suggestion) { return _this.props.getSuggestionValue(suggestion).match(regex_1); })];
                }
                else {
                    return [2 /*return*/, suggestions || []];
                }
                return [2 /*return*/];
            });
        });
    };
    AutoCompleteInput.prototype.render = function () {
        var _a = this.props, inputProps = _a.inputProps, getSuggestionValue = _a.getSuggestionValue, maxSuggestions = _a.maxSuggestions, focusInputOnSuggestionClick = _a.focusInputOnSuggestionClick;
        var _b = this.state, inputValue = _b.inputValue, suggestions = _b.suggestions;
        return (react_1.default.createElement(react_autosuggest_1.default, { id: this.id, suggestions: suggestions.slice(0, maxSuggestions), onSuggestionSelected: this.onSuggestionSelected, onSuggestionsFetchRequested: this.debouncedFetchRequest, onSuggestionsClearRequested: this.onSuggestionsClearRequested, getSuggestionValue: getSuggestionValue, renderSuggestion: this.renderSuggestion, renderSuggestionsContainer: this.renderSuggestionContainer, inputProps: __assign(__assign({}, (inputProps || {})), { value: inputValue, onChange: this.onInputChange, onKeyDown: this.onInputKeyDown }), renderInputComponent: this.renderInputComponent, shouldRenderSuggestions: this.shouldRenderSuggestions, focusInputOnSuggestionClick: focusInputOnSuggestionClick, theme: AutoCompleteInput.theme }));
    };
    AutoCompleteInput.id = 0;
    AutoCompleteInput.defaultProps = {
        inputProps: {},
        suggestions: [],
        getSuggestionValue: function (suggestion) { return suggestion; },
        maxSuggestions: 7,
        renderSuggestionsOnFocus: false,
        focusInputOnSuggestionClick: false,
        showHeaderText: false,
        showDeleteText: false,
        preventEnterOnSuggestionSelection: true,
    };
    AutoCompleteInput.theme = {
        container: "respectkit__autocomplete",
        containerOpen: "respectkit__autocomplete-open",
        suggestionsContainer: "respectkit__autocomplete__suggestions-container",
        suggestionsContainerOpen: "respectkit__autocomplete__suggestions-container-open",
        suggestionsList: "respectkit__autocomplete__suggestions-list",
        suggestion: "respectkit__autocomplete__suggestion",
    };
    return AutoCompleteInput;
}(react_1.PureComponent));
exports.default = AutoCompleteInput;
//# sourceMappingURL=index.js.map